// extracted by mini-css-extract-plugin
export var connectionButton = "_bs-1";
export var rightPanel = "_bs-3";
export var stepDescription = "_bs-2";
export var stepIcon = "_bs-0";